// packages/api-client/queries/styles/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createStylesQueries = (requests, queryClient) => ({
    useListStyles: (params, options = {}) => useQuery({
        queryKey: ["styles", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listStyles(params);
        },
        ...options,
    }),
    useFindStyle: (params, options = {}) => useQuery({
        queryKey: ["style", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findStyle(params);
        },
        ...options,
    }),
    useCreateStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleAttrs) => {
            return requests.createStyle(styleAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["styles"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleAttrs) => {
            return requests.updateStyle(styleAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["styles"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleId) => {
            return requests.deleteStyle(styleId);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["styles"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useApproveStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleAttrs) => {
            return requests.approveStyle(styleAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["styles"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useExportStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.exportStyle(attrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useGenerateGuidelines: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => {
            return requests.generateGuidelines(payload);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["style"] });
            queryClient.invalidateQueries({ queryKey: ["styles"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map